import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { Euler, useLoader, Vector3 } from "@react-three/fiber";
import { forwardRef, useImperativeHandle, useRef } from "react";
import * as THREE from "three";

type GamepadProps = {
    pos?: Vector3,
    euler?: Euler
}


export const Gamepad = forwardRef((props: GamepadProps, ref) => {
    const controllerBody = useLoader(STLLoader, "/stl/gamepad/controller_body.stl");
    const dPad = useLoader(STLLoader, "/stl/gamepad/d_pad.stl");
    const thumbStick = useLoader(STLLoader, "/stl/gamepad/thumb_stick.stl");
    const button = useLoader(STLLoader, "/stl/gamepad/game_action_button.stl");

    const meshRef = useRef<any>();

    useImperativeHandle(ref, () => ({
        getBoundingBox() {
            if(meshRef?.current) {
                meshRef.current.geometry.computeBoundingBox();

                let vecCenter = new THREE.Vector3();
                let boundingBox = meshRef.current.geometry.boundingBox;

                boundingBox.getCenter(vecCenter);

                return vecCenter;
            } 
        }
    }));

    return (
        <>
            <group position={props.pos} rotation={props.euler}>
                {/* The controller body. */}
                <mesh ref={meshRef} position={[0, 0, 0.025]}>
                    <primitive object={controllerBody} attach="geometry" />
                    <meshStandardMaterial color={[0.749, 0.749, 0.749]} />
                </mesh>

                {/* The D-Pad. */}
                <mesh ref={meshRef} position={[-0.004, 0.00675, 0.0442]}>
                    <primitive object={dPad} attach="geometry" />
                    <meshStandardMaterial color={[0, 0, 0]} />
                </mesh>

                {/* The thumb sticks. */}
                <mesh ref={meshRef} position={[0.0275, -0.0225, 0.039375]}>
                    <primitive object={thumbStick} attach="geometry" />
                    <meshStandardMaterial color={[0, 0, 0]} />
                </mesh>
                <mesh ref={meshRef} position={[0.112500004, -0.0225, 0.039375]}>
                    <primitive object={thumbStick} attach="geometry" />
                    <meshStandardMaterial color={[0, 0, 0]} />
                </mesh>

                {/* The action buttons. */}
                <group position={[0, 0, -0.005]}>
                    <mesh ref={meshRef} position={[0.1275, 0.01, 0.05]}>
                        <primitive object={button} attach="geometry" />
                        <meshStandardMaterial color={[0, 1, 0]} />
                    </mesh>
                    <mesh ref={meshRef} position={[0.14375, -0.0025, 0.05]}>
                        <primitive object={button} attach="geometry" />
                        <meshStandardMaterial color={[1, 1, 0]} />
                    </mesh>
                    <mesh ref={meshRef} position={[0.14186332, 0.022052262, 0.05]}>
                        <primitive object={button} attach="geometry" />
                        <meshStandardMaterial color={[0, 0, 1]} />
                    </mesh>
                    <mesh ref={meshRef} position={[0.15811333, 0.009552263, 0.05]}>
                        <primitive object={button} attach="geometry" />
                        <meshStandardMaterial color={[1, 0, 0]} />
                    </mesh>
                </group>

            </group>

        </>
    );
});

